import { useMutation } from '@tanstack/react-query';
import { IWebsiteCreationDto, requestWebsiteCreation } from 'services';
import { useGetCompanyInfo } from 'hooks';
import { useGlobalStoreUser } from 'hooks/useGlobalStoreUser/useGlobalStoreUser';
import { IRequestWebsiteForm } from 'interface/WizardV3';

const errorMessage = 'Something went wrong, please try again later.';
export function useRequestWebsiteCreation({ enqueueSnackbar }) {
  const userGlobalStore = useGlobalStoreUser();
  const companyInfo = useGetCompanyInfo();
  const companyName = companyInfo.data?.companyName || '';
  const corpAcctNbr = userGlobalStore?.profileDTO?.corpAcctNbr;
  const contactName =
    `${userGlobalStore?.firstName} ${userGlobalStore?.lastName}` || '';
  const email = userGlobalStore?.email || '';

  return useMutation({
    mutationFn: (websiteformData: IRequestWebsiteForm) => {
      const websiteCreationDto: IWebsiteCreationDto = {
        companyName,
        contactName,
        corpAcctNumber: corpAcctNbr,
        packageSelected: websiteformData.packageSelected || 'Pro',
        phoneNumber: websiteformData.phoneNumber || '',
        submitRegistration: 'Y',
        subscriptionType: websiteformData.subscriptionType || 'Monthly',
        userEmail: websiteformData.userEmail || email,
      };
      return requestWebsiteCreation(corpAcctNbr, websiteCreationDto);
    },
    onSuccess: () => {
      enqueueSnackbar('Website request submitted successfully!');
    },
    onError: (error) => {
      const errorResponse = error as {
        response?: { data?: { displayMessage?: string } };
      };
      enqueueSnackbar({
        message: errorResponse?.response?.data?.displayMessage || errorMessage,
      });
    },
  });
}
